import { render, staticRenderFns } from "./PaRevenue.vue?vue&type=template&id=28edcde6&scoped=true"
import script from "./PaRevenue.vue?vue&type=script&lang=js"
export * from "./PaRevenue.vue?vue&type=script&lang=js"
import style0 from "./PaRevenue.vue?vue&type=style&index=0&id=28edcde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edcde6",
  null
  
)

export default component.exports